import { timer } from 'rxjs'

const activeAlerts: HTMLElement[] = []

export const commonUtil = {
  alert(msg: string, type: string, delayMs = 2000) {
    let alertContainer = document.getElementById('alert-container')
    if (!alertContainer) {
      alertContainer = document.createElement('div')
      alertContainer.id = 'alert-container'
      alertContainer.className = 'position-fixed top-0 start-50 translate-middle-x'
      alertContainer.style.zIndex = '9999'
      alertContainer.style.maxWidth = '90vw'
      alertContainer.style.width = 'auto'
      alertContainer.style.minWidth = '300px'
      alertContainer.style.paddingTop = '20px'
      document.body.appendChild(alertContainer)
    }

    const div = document.createElement('div')
    div.className = `alert alert-${type} shadow-lg fade show`
    div.setAttribute('role', 'alert')
    div.style.padding = '16px 20px'
    div.style.margin = '0'
    div.style.marginBottom = '10px'
    div.style.transition = 'all 0.3s ease'

    div.textContent = msg
    alertContainer.appendChild(div)
    activeAlerts.push(div)

    timer(delayMs).subscribe(() => {
      div.classList.remove('show')
      div.classList.add('hide')
      setTimeout(() => {
        div.remove()
        const index = activeAlerts.indexOf(div)
        if (index > -1) {
          activeAlerts.splice(index, 1)
        }
        if (activeAlerts.length === 0) {
          alertContainer.remove()
        }
      }, 300)
    })
  }
}
